import './LoadingScreen.css';

interface LoadingScreenProps {
  /** 0..1 progress fraction. When undefined, shows indeterminate animation. */
  progress?: number;
  /** Current step label (e.g. "Loading 3D models…") */
  label?: string;
}

export default function LoadingScreen({ progress, label }: LoadingScreenProps) {
  const hasProgress = progress !== undefined;
  const percent = hasProgress ? Math.round(progress * 100) : 0;

  return (
    <div className="loading-screen">
      <div className="loading-screen__content">
        <h1 className="loading-screen__title">RACEPROX</h1>
        <p className="loading-screen__subtitle">TV Showcase</p>

        <div className="loading-screen__bar-track">
          <div
            className={`loading-screen__bar-fill ${!hasProgress ? 'loading-screen__bar-fill--indeterminate' : ''}`}
            style={hasProgress ? { width: `${percent}%` } : undefined}
          />
        </div>

        {hasProgress && (
          <div className="loading-screen__info">
            <span className="loading-screen__percent">{percent}%</span>
            {label && <span className="loading-screen__label">{label}</span>}
          </div>
        )}
      </div>
    </div>
  );
}
